import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';

import {checkToken} from '../services/login';

import authReducer from './authReducer';
import templateReducer from './templateReducer';
import topicsReducer from './topicsReducer';
import calculationReducer from './calculationReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

checkToken();

const reducers=combineReducers({
  auth: authReducer,
  template: templateReducer,
  topics: topicsReducer,
  calculation: calculationReducer
})

const store = createStore(reducers,composeEnhancers(applyMiddleware(thunk)));

export default store;